export default {"src":"/_next/static/media/nuviad_logo_on_black.f7199003.svg","height":153,"width":552,"blurWidth":0,"blurHeight":0};